<script lang="ts" setup>
  import { ref } from 'vue'
  import Drawer from 'primevue/drawer'
  import ButtonDefault from '@/elements/ButtonDefault.vue'
  import NavigationShared from '@/components/layout/NavigationShared.vue'
  import LogoDefault from './LogoDefault.vue'

  defineProps({
    navigation: Array
  })
  const isVisible = ref(false)

  useEventBus('showMobileMenuClick').on(() => {
    isVisible.value = true
  })
</script>

<template>
  <div>
    <div>
      <ButtonDefault
        v-if="!isVisible"
        @click="isVisible = !isVisible"
        outlined
        icon="MenuOpenIcon"
        severity="secondary" />
      <ButtonDefault
        v-else-if="isVisible"
        @click="isVisible = !isVisible"
        outlined
        icon="MenuCloseIcon"
        severity="secondary" />
    </div>
    <Drawer v-model:visible="isVisible" position="right">
      <template #header>
        <div class="flex h-16 shrink-0 items-center">
          <RouterLink
            :to="$router.resolve('/')"
            active-class=""
            class="flex h-16 shrink-0 items-center"
            exact-active-class="">
            <LogoDefault class="h-8 w-auto" />
          </RouterLink>
        </div>
      </template>
      <template #closeicon>
        <component is="MenuCloseIcon" class="size-6" />
      </template>
      <div class="flex grow flex-col gap-y-5 bg-white dark:bg-black px-2 pb-2">
        <nav class="flex flex-1 flex-col">
          <NavigationShared @link-click="isVisible = false" />
        </nav>
      </div>
    </Drawer>
  </div>
</template>

<style scoped></style>
